import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	gap: 20px;
	grid-gap: 20px;

	.horizontal-ruller {
		border: 1px solid #d8dee6;
		margin: 20px 0;
	}
`;

export const Banner = styled.div`
	border-radius: 10px;
	background-color: ${tokens.color_gray_light};
	padding: 30px;
	height: 442px;
`;

export const Title = styled.div`
	display: grid;
	grid-template-columns: 55px 1fr;
	gap: 20px;
	grid-gap: 20px;
`;

export const Benefits = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 26px;
	grid-gap: 26px;
`;

export const BenefitItem = styled.div`
	display: grid;
	grid-template-columns: 55px 1fr;
	gap: 16px;
	grid-gap: 16px;
`;

export const InfoContainer = styled.div`
	margin-top: 30px;
	height: 242px;
`;

export const MoreInfo = styled.div`
	display: grid;
	place-content: center;
`;
